/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useInView } from 'react-intersection-observer';
import React, { useState } from 'react';
import { Grid, Box, Flex, Text } from 'theme-ui';
import { motion } from 'framer-motion';
import Img from 'gatsby-image';
import styled from '@emotion/styled';
import Color from 'color';
import Helmet from 'react-helmet';
import Heading from '../Heading';
import Richtext from '../Richtext';
import Schlingeling from '../Schlingeling';
import Header from '../Header';

const Shadow = styled(motion.div)`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
`;

const shadowVariants = {
  mouseleave: {
    x: -18,
    y: 18,
  },
  mouseenter: {
    x: 0,
    y: 0,
  },
};

const ProjectHero = ({ data }) => {
  const [shadow, setShadow] = useState('mouseleave');
  const contrastRatio = [
    Color('#3B4AB6').contrast(Color(data.backgroundColor?.hex)),
    Color('#fff').contrast(Color(data.backgroundColor?.hex)),
  ];

  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
  });

  return (
    <Box sx={{ backgroundColor: data.backgroundColor?.hex }} ref={ref}>
      <Helmet>
        {inView ? (
          <meta name="theme-color" content={data.backgroundColor?.hex} />
        ) : (
          <meta name="theme-color" content="#fff" />
        )}
      </Helmet>
      {contrastRatio.indexOf(Math.max(...contrastRatio)) === 0 ? (
        <Header appearance="dark" />
      ) : (
        <Header appearance="light" />
      )}
      <Grid
        columns={['repeat(4, 1fr)', 'repeat(12, 1fr)']}
        gap={4}
        sx={{ maxWidth: 240, mx: [3, 'auto'], mt: [10, 20], mb: [0, 10] }}
      >
        <Box
          sx={{
            gridColumn: ['1/ span 4', '1/ span 12', '2/ span 10', '2/ span 7'],
            gridRow: ['1'],
          }}
        >
          <Img fluid={data.featuredImage.asset.fluid} />
          {/* <img
            alt={`${data.title}`}
            sx={{
              // objectFit: 'cover',
              maxWidth: '100%',
              height: 'auto',
            }}
            src={data.featuredImage.asset.fixed.src}
          /> */}
        </Box>
        <Box
          sx={{
            position: 'relative',
            gridColumn: ['1/ span 4', '1/ span 12', '3/ span 8', '8/ span 4'],
            gridRow: ['2', '2', '2', '1'],
          }}
        >
          <Box
            sx={{
              marginTop: [0, -11, null, 5],
              py: 5,
              px: 8,
              position: 'relative',
              zIndex: 1,
            }}
          >
            <Shadow
              initial="mouseleave"
              animate={shadow}
              variants={shadowVariants}
              sx={{
                background: data.backgroundColor?.hex,
                zIndex: -1,
              }}
            />
            <Shadow
              sx={{
                backgroundColor: 'white',
                zIndex: 0,
              }}
            />
            <Box
              sx={{ position: 'relative', zIndex: 1 }}
              onMouseEnter={(event) => setShadow(event.type)}
              onMouseLeave={(event) => setShadow(event.type)}
            >
              <Heading variant="h1" color={data.titleColor?.hex}>
                {data.title}
              </Heading>
              <Heading
                variant="subtitle"
                color="text"
                sx={{ mt: [-3, -5], mb: 4 }}
              >
                {data.category}
              </Heading>
              <Text variant="body">
                <Richtext content={data._rawExcerpt} />
              </Text>
            </Box>
          </Box>
        </Box>
      </Grid>
      <Flex
        sx={{
          justifyContent: 'center',
          paddingTop: 5,
          paddingBottom: [5, 15],
        }}
      >
        <Schlingeling
          leftColor={data.schlingelingLeftColor?.hex}
          rightColor={data.schlingelingRightColor?.hex}
        />
      </Flex>
    </Box>
  );
};

export default ProjectHero;
